"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const DeleteButton = ({ onDelete, children }) => (react_1.default.createElement("button", { className: "text-red-600 focus:outline-none hover:underline", tabIndex: -1, type: "button", onClick: onDelete }, children));
exports.default = DeleteButton;
